import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cellEditorControlIdPipe',
})
export class CellEditorControlIdPipe implements PipeTransform {

  transform(cellEditorControlId: string, ...args): any {

    if (cellEditorControlId == null) {
      return null;
    }
    return cellEditorControlId.replace(/\./g, '-');
  }
}
